import { Row } from "react-bootstrap";
import PhaseCountCard from "./PhaseCountCard";
import { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPhaseCount,
  getPhseWisePatient,
  setFilterLocation,
} from "redux/reducers/Dashboard/dashboard.slice";

const PhaseCount = () => {
  const dispatch = useDispatch();
  const { selectedLocation } = useSelector(({ role }) => role);
  const { phaseCount, filterOption } = useSelector(
    ({ dashboard }) => dashboard
  );

  const fetchPhaseWisePatientList = useCallback(() => {
    const payload = {
      filter_location_id: selectedLocation,
      phase:
        filterOption === "5" ? [] : Array.from(String(filterOption), Number),
    };

    dispatch(
      getPhseWisePatient({
        location_id: selectedLocation,
        start: 1,
        limit: 10,
        payload,
      })
    );
  }, [dispatch, selectedLocation]);

  useEffect(() => {
    fetchPhaseWisePatientList();
    dispatch(getPhaseCount(selectedLocation));
    dispatch(setFilterLocation(selectedLocation));
  }, []);

  return (
    <div>
      <Row className="home_card_partition pt-lg-0 pt-2 m-0 mb-3">
        <PhaseCountCard
          count={phaseCount?.phase1Count}
          percent={phaseCount?.phase1Percent}
          thisWeekCount={phaseCount?.thisWeekPhase1Count}
          phase={1}
        />
        <PhaseCountCard
          count={phaseCount?.phase2Count}
          percent={phaseCount?.phase2Percent}
          thisWeekCount={phaseCount?.thisWeekPhase2Count}
          phase={2}
        />
        <PhaseCountCard
          count={phaseCount?.phase3Count}
          percent={phaseCount?.phase3Percent}
          thisWeekCount={phaseCount?.thisWeekPhase3Count}
          phase={3}
        />
        <PhaseCountCard
          count={phaseCount?.phase4Count}
          percent={phaseCount?.phase4Percent}
          thisWeekCount={phaseCount?.thisWeekPhase4Count}
          phase={4}
        />
      </Row>
    </div>
  );
};
export default memo(PhaseCount);
